// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2mdI5","label":"Category_label__2a4YC","content":"Category_content__1hThM","header":"Category_header__O3Ksf","location":"Category_location__PTjX0"};